import React from 'react';
import styled from '@emotion/styled';
import MUIPaper from '@material-ui/core/Paper';
import { Spacings } from '@styles/index';

interface PaperProps {
  className?: string;
  bgColor?: string;
  padding?: string;
  gridColumn?: string;
  children?: React.ReactNode | React.ReactNode[];
}

type BasePaperProps = {
  $bgColor?: string;
  $padding?: string;
  $gridColumn?: string;
};

const StyledPaper = styled(MUIPaper)<BasePaperProps>`
  padding: ${({ $padding }) => $padding || Spacings.SPACING_8B};
  background-color: ${({ $bgColor }) =>
    $bgColor || 'var(--color-i-icon-dark-primary)'};
  grid-column: ${({ $gridColumn }) => $gridColumn};
  border-radius: 8px;
  border: none !important;
  color: var(--color-i-icon-light-tertiary);
`;

const Paper: React.FC<PaperProps> = ({
  className,
  bgColor,
  children,
  padding,
  gridColumn
}) => {
  return (
    <StyledPaper
      className={className}
      $bgColor={bgColor}
      $gridColumn={gridColumn}
      $padding={padding}
    >
      {children}
    </StyledPaper>
  );
};

Paper.displayName = 'Paper';

export default Paper;
